import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppFile} from '../../entities/AppFile';
import {Task} from 'app/entities/Task';

@Component({
  selector: 'app-file-handler-view',
  templateUrl: './file-handler-view.component.html',
  styleUrls: ['./file-handler-view.component.css']
})
export class FileHandlerViewComponent implements OnInit {

  @Input('DoneLoading')
  set DoneLoading(loading: boolean) {
    if(loading) {
      this.filesToUpload = [];
    }
  }
  @Input('FilesToDownload')
  set files(files: AppFile[]) {
    this.filesToDownload = files;
  }

  @Input('ChosenTask')
  set ChosenTask(task: Task) {
    if(task != undefined){
      this.chosenTask = task;
    }
    else{
      this.chosenTask = new Task();
    }
  }

  @Input('CreateModalOpenChanged')
  set createModalOpenChanged(value: boolean){
    this.createTaskOpen = value;
  }

  @Input('FilesToUpload')
  set filesUpload(value: AppFile[]){
    this.filesToUpload = value;
  }

  @Input('Loading')
  set Loading(value: boolean) {
    this.loading = value;
  }

  @Output()
  uploadFileEmitter= new EventEmitter();

  @Output()
  onFileChangeEmitter = new EventEmitter();

  @Output()
  uploadFilesEmitter = new EventEmitter();

  @Output()
  downloadFileEmitter = new EventEmitter();

  @ViewChild('myInput')
  fileChooserValue: ElementRef;

  constructor() {
  }

  filesToUpload: AppFile[];
  filesToDownload: AppFile[] = [];
  chosenTask: Task;
  loading: boolean;
  toggleOpen: boolean;
  createTaskOpen: boolean;

  ngOnInit() {
    this.toggleOpen = false;
    console.log("Mikkel object");
  }

  downloadFile(file) {
    this.downloadFileEmitter.emit(file);
  }

  uploadFileTemp(file: AppFile){
    this.uploadFileEmitter.emit(file);
  }

  uploadFiles() {
    this.uploadFilesEmitter.emit();
  }

  onFileChange($event) {
    const files = $event.target.files;
    const fcValue = this.fileChooserValue;
    const self = this;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const fileReader = new FileReader();
        let textFromFileLoaded;
        fileReader.onload = function (fileLoadedEvent: any) {
          textFromFileLoaded = fileLoadedEvent.target.result;

          const newFile = new AppFile();
          // base 64 encode
          newFile.File = btoa(textFromFileLoaded);
          newFile.Key = '';
          newFile.Type = 'App Task';
          newFile.FileName = file.name;

          let d = new Date();
          newFile.Created_DateTime = d.toDateString();
          self.uploadFileTemp(newFile);
          console.log(newFile);
          //filesToUpload.push(newFile);
          if (i === files.length - 1) {
            fcValue.nativeElement.value = '';
          }
        };
        fileReader.readAsBinaryString(file);

      }
    }
  }

  removeFile(file: AppFile) {
    const index = this.filesToUpload.indexOf(file);
    if (index > -1) {
      this.filesToUpload.splice(index, 1);
    }
  }

  changeToggleOpen(){
    this.toggleOpen = !this.toggleOpen;
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/file-handler/file-handler-view.component.ts